import React, {useEffect, useState} from "react";
import {logError} from "../../model/utils";
import '../Lg.css';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {LgShortFooter} from "./LgShortFooter";
import {LgShortHeader} from "./LgShortHeader";
import {LgTeamFooter} from "./LgTeamFooter";
import {LgFullFooter} from "./LgFullFooter";
import {LgFullHeader} from "./LgFullHeader";
import {LmFooter} from "./LmFooter";
import {getProfile} from "../../../logic_tmp/storage/LgProfile";
import {registerConcersion} from "../../../logic/funel/FacebookUtils";
import {prepareGeo, setCyrcleEnv} from "./common/LgHelper";
import {appdata} from "../../../logic_tmp/appdata/AppData";
import {LrrhFooter} from "../../Lrrh/LrrhFooter";
import {LrrhHeader} from "../../Lrrh/LrrhHeader";
import {sendHeight} from "../../../resizer";
import {ZerroFooter} from "./ZerroFooter";
import {ConcertShortFooter} from "./ConcertShortFooter";
import {CelloLgFooter} from "./CelloLgFooter";


function WidgetRouter() {
    useEffect(() => {
        if (appdata.iframeId === undefined)
            throw Error("Missed frameid parameter")
        sendHeight("Widget effect")
    });

    return (
        <div>
            <BrowserRouter>
                <Switch>
                    <Route path="/tilda/cello-lg-router">
                        <CelloLgFooter/>
                    </Route>
                    <Route path="/tilda/concert-short-footer">
                        <ConcertShortFooter/>
                    </Route>
                    <Route path="/tilda/zerro-footer">
                        <ZerroFooter/>
                    </Route>
                    <Route path="/tilda/lg-short-footer">
                        <LgShortFooter/>
                    </Route>
                    <Route path="/tilda/lg-short-header">
                        <LgShortHeader/>
                    </Route>
                    <Route path="/tilda/lg-team-footer">
                        <LgTeamFooter/>
                    </Route>
                    <Route path="/tilda/lg-full-footer">
                        <LgFullFooter/>
                    </Route>
                    <Route path="/tilda/lg-full-header">
                        <LgFullHeader/>
                    </Route>
                    <Route path="/tilda/lm-footer">
                        <LmFooter/>
                    </Route>
                    <Route path="/tilda/lrrh-footer">
                        <LrrhFooter/>
                    </Route>
                    <Route path="/tilda/lrrh-header">
                        <LrrhHeader/>
                    </Route>
                </Switch>
            </BrowserRouter>
        </div>
    )
}


export function TildaWidget() {
    const [isLoading, setLoading] = useState(true);
    useEffect(() => {
        if (appdata.action === "CIRCLE") {
            setCyrcleEnv(appdata, getProfile())
        }
        if (appdata["geoCode"] !== undefined)
            prepareGeo(appdata).then(r => {
                //registerConcersion('PageView')
                setLoading(false)
            })
        else
            setLoading(false)
    }, []);

    try {
        return (
            <div>
                {(isLoading) ? <div>...</div> :
                    <WidgetRouter></WidgetRouter>
                }
            </div>
        );
    } catch (e) {
        logError(e)


        return (<div>Something went wrong...</div>)
    }
}

